function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedsActive = function SvgFeedsActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.47929 6.04939C0.6623 6.04939 0 6.71169 0 7.52868V12.3364C0 13.1534 0.6623 13.8157 1.47929 13.8157C2.29628 13.8157 2.95858 13.1534 2.95858 12.3364V7.52868C2.95858 6.71127 2.29628 6.04939 1.47929 6.04939Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73961 3.32841C4.92261 3.32841 4.26031 3.99071 4.26031 4.80771V15.0571C4.26031 15.8741 4.92261 16.5364 5.73961 16.5364C6.5566 16.5364 7.2189 15.8741 7.2189 15.0571V4.80771C7.2189 3.99071 6.5566 3.32841 5.73961 3.32841Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0C9.18299 0 8.52069 0.6623 8.52069 1.47929V18.3855C8.52069 19.2025 9.18299 19.8648 9.99998 19.8648C10.817 19.8648 11.4793 19.2025 11.4793 18.3855V1.47929C11.4793 0.6623 10.817 0 9.99998 0Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5207 6.04939C17.7037 6.04939 17.0414 6.71169 17.0414 7.52868V12.3364C17.0414 13.1534 17.7037 13.8157 18.5207 13.8157C19.3377 13.8157 20 13.1534 20 12.3364V7.52868C20 6.71127 19.3377 6.04939 18.5207 6.04939Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2604 3.32841C13.4434 3.32841 12.7811 3.99071 12.7811 4.80771V15.0571C12.7811 15.8741 13.4434 16.5364 14.2604 16.5364C15.0773 16.5364 15.7396 15.8741 15.7396 15.0571V4.80771C15.7396 3.99071 15.0773 3.32841 14.2604 3.32841Z",
    style: {
      fill: "var(--color-primary)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedsActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feeds-active.bf31364e.svg";
export { ForwardRef as ReactComponent };